export const GetNisabActionTypes = {
  GET_NISAB_LOADING: "GET_NISAB_LOADING",
  GET_NISAB_ERROR: "GET_NISAB_ERROR",
  GET_NISAB_SUCCESS: "GET_NISAB_SUCCESS",
};
